import { EntitlementServiceType, EntitlementsResponse } from '../api/hooks/contract';

/** 병원에 살아 있는 STIM 재택 계약이 있는지. 미로딩(undefined)은 false 로 본다. */
export const isStimHomeEntitled = (entitlements?: EntitlementsResponse): boolean =>
  (entitlements?.services ?? []).some((v) => v.serviceType === EntitlementServiceType.StimHome && v.entitled);
